import React from 'react';
import { formatDate } from '../../../../utils/helper';

function BookAppointmentStatus(props) {
  const { isModalOpen, setAppointmnetModal, order, dataLocale } = props;
  const { BOOK_YOUR_APPOINTMENT, SELECT_TIME, CHANGE, BOOK_NOW, APPOINTMENT_BOOKED } = dataLocale;
  const handleBookAppointment = () => {
    setAppointmnetModal(!isModalOpen);
  };
  const bookDetails = order =>
    `${formatDate(Date.parse(order.studioBookingDetails.date), 'D MMM')}, 
              ${`${order?.studioBookingDetails?.startTime?.split(':')?.slice(0, 2)?.join(':')}`} -
              ${`${order?.studioBookingDetails?.endTime?.split(':')?.slice(0, 2)?.join(':')}`} ${
      'studioStoreDetails' in order
        ? `, ${order.studioStoreDetails.name || order.shippingAddress.firstName}`
        : ''
    }`;
  return (
    <div className="order-pay-now bora-8 justify-space-between align-items-center display-flex desktop padding-12 bg-color-white margin-t10 margin-b15 margin-l20 margin-r20">
      <div className="flex-basis-80">
        <div className="text-color-33 fs16 fw700">
          {'studioBookingDetails' in order ? APPOINTMENT_BOOKED : BOOK_YOUR_APPOINTMENT}
        </div>
        <div className="text-color-33 fs14 lh-14">
          {'studioBookingDetails' in order ? bookDetails(order) : SELECT_TIME}
        </div>
      </div>
      <div
        className="fs14 padding-t10 cursor-pointer padding-b10 text-color-white bg-color-primary no-decoration flex-basis-20 text-center block bora-4 fw700 text-uppercase"
        onClick={handleBookAppointment}
      >
        {'studioBookingDetails' in order ? CHANGE : BOOK_NOW}
      </div>
    </div>
  );
}

export default BookAppointmentStatus;
